import { render, staticRenderFns } from "./salesCounter.vue?vue&type=template&id=3cb398fe&scoped=true&"
import script from "./salesCounter.vue?vue&type=script&lang=js&"
export * from "./salesCounter.vue?vue&type=script&lang=js&"
import style0 from "./salesCounter.vue?vue&type=style&index=0&id=3cb398fe&prod&scoped=true&lang=css&"
import style1 from "./salesCounter.vue?vue&type=style&index=1&id=3cb398fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb398fe",
  null
  
)

export default component.exports